export type TagSize = 'large' | 'small';

export const TAG_SIZES: Record<string, TagSize> = {
  LARGE: 'large',
  SMALL: 'small',
};
